import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useLang } from "@/lib/i18n";

const KEY = "x10_cookie_consent";

export default function CookieBanner() {
  const { t } = useLang();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const v = localStorage.getItem(KEY);
    if (!v) {
      const timer = setTimeout(() => setOpen(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setOpen(false);
  };

  if (!open) return null;
  if (location.pathname.startsWith("/admin")) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 sm:left-6 sm:bottom-6 sm:right-auto sm:max-w-md z-[60] animate-in fade-in slide-in-from-bottom-4"
      style={{ animation: "fadeUp 0.5s ease-out forwards" }}
    >
      <div className="bg-white border border-slate-200 shadow-2xl rounded-2xl p-6">
        <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#1E3A8A] mb-3">
          {t("cookies.title")}
        </div>
        <p className="text-sm text-slate-600 leading-relaxed">
          {t("cookies.body")}{" "}
          <Link to="/datenschutz" className="underline text-[#0A192F] hover:text-[#1E3A8A]" data-testid="cookie-banner-learn">
            {t("cookies.learn")}
          </Link>
        </p>
        <div className="mt-5 flex flex-wrap gap-2">
          <button
            data-testid="cookie-accept"
            onClick={() => decide("accepted")}
            className="px-4 py-2 bg-[#0A192F] text-white rounded-full text-sm font-semibold hover:bg-[#1E3A8A] transition-colors"
          >
            {t("cookies.accept")}
          </button>
          <button
            data-testid="cookie-decline"
            onClick={() => decide("declined")}
            className="px-4 py-2 border border-slate-300 text-slate-700 rounded-full text-sm font-semibold hover:bg-slate-50 transition-colors"
          >
            {t("cookies.decline")}
          </button>
        </div>
      </div>
    </div>
  );
}
